function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.6174 18.5342L14.444 2.6454C13.9339 1.76191 13.0203 1.23438 12 1.23438C10.9798 1.23438 10.0661 1.76191 9.55598 2.6454L0.382605 18.5342C-0.127535 19.4178 -0.127535 20.4727 0.382605 21.3563C0.892744 22.2398 1.80634 22.7673 2.82662 22.7673H21.1734C22.1936 22.7673 23.1072 22.2398 23.6174 21.3563C24.1276 20.4727 24.1276 19.4178 23.6174 18.5342ZM22.3997 20.6533C22.1437 21.0966 21.6853 21.3613 21.1734 21.3613H2.82662C2.31465 21.3613 1.85621 21.0966 1.60027 20.6533C1.34434 20.2099 1.34434 19.6806 1.60027 19.2373L10.7737 3.34848C11.0297 2.90514 11.4881 2.64048 12 2.64048C12.5119 2.64048 12.9704 2.90514 13.2263 3.34848L22.3998 19.2373C22.6556 19.6806 22.6556 20.2099 22.3997 20.6533Z",
  fill: "#D32F2F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.7029 8.25H11.2969V15.2804H12.7029V8.25Z",
  fill: "#D32F2F"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 16.6875C11.483 16.6875 11.0625 17.108 11.0625 17.6249C11.0625 18.1418 11.483 18.5623 11.9999 18.5623C12.5167 18.5623 12.9373 18.1418 12.9373 17.6249C12.9373 17.108 12.5168 16.6875 11.9999 16.6875Z",
  fill: "#D32F2F"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

var SvgAlertTrans = function SvgAlertTrans(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlertTrans, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alertTrans.928a9bd3.svg";
export { ForwardRef as ReactComponent };